import React from "react";
import Div from "../../../../widget/common/ui/Div";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { LogoRound } from "../../../../widget/common/ui/Logo";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { textCase } from "../../../../service/ui/UI";
import { ChatsContextImport } from "../../../../provider/chats/chats/chats/ChatsContextProvider";
import { TeamChatsContextImport } from "../../../../provider/chats/chats/team_chats/TeamChatsContextProvider";
import { Position, Stack } from "../../../../widget/common/ui/Stack";
import { CheckBoxRound } from "../../../../widget/common/ui/Checkbox";
import { DepartmentChatsContextImport } from "../../../../provider/chats/chats/department_chats/DepartmentChatsContextProvider";
import { GroupChatsContextImport } from "../../../../provider/chats/chats/group_chats/GroupChatsContextProvider";
import { SpacingHeight } from "../../../../widget/common/ui/Spacing";
import AppConfigService from "../../../../service/app_config/AppConfigService";

export const ConversationHeaders = () => {
  const type: number = ResponsiveDeviceType();

  const { chatSelected } = ChatsContextImport();

  const teamChatsContextImport = TeamChatsContextImport();
  const departmentChatsContextImport = DepartmentChatsContextImport();
  const groupChatsContextImport = GroupChatsContextImport();

  return (
    <>
      {chatSelected != null && (
        <Div className="chat-header-pofile">
          <Div className="d-flex align-items-center">
            <Stack>
              <LogoRound
                url={
                  chatSelected?.flag === "3"
                    ? chatSelected?.logo! ||
                      AppConfigService.get("company_logo")
                    : chatSelected?.logo!
                }
                isProfile={true}
                name={chatSelected?.name!}
                size={type === 2 ? 50 : 40}
              />
              {["1", "4"].includes(chatSelected?.flag!) &&
                teamChatsContextImport.onlineStatus && (
                  <Position bottom={0} right={0}>
                    <CheckBoxRound
                      status={false}
                      size={10}
                      fillColor="bgcolor-green2"
                    />
                  </Position>
                )}
            </Stack>
            <Div className="ps-2">
              <TextBlock
                fontName="bold"
                fontSize="18_19"
                textColor="theme-font"
                maxLine={1}
              >
                {textCase(chatSelected?.name!)}
              </TextBlock>
              <SpacingHeight value={2} />
              <TextBlock
                fontName="book"
                fontSize="14_15"
                textColor="theme-font"
                maxLine={1}
              >
                {(["1", "4"].includes(chatSelected?.flag!) &&
                  teamChatsContextImport.typingStatus) ||
                (chatSelected?.flag === "2" &&
                  departmentChatsContextImport.typingStatus)
                  ? "typing..."
                  : (["1", "4"].includes(chatSelected?.flag!) &&
                      teamChatsContextImport.recordingStatus) ||
                    (chatSelected?.flag === "2" &&
                      departmentChatsContextImport.recordingStatus)
                  ? "recording..."
                  : chatSelected?.flag === "3"
                  ? groupChatsContextImport.conversationDetail != null &&
                    !groupChatsContextImport.removedMember
                    ? groupChatsContextImport.onlineStatus
                      ? `${
                          groupChatsContextImport.groupMembersOnline.filter(
                            (element) => element === true
                          ).length
                        } online`
                      : `${
                          groupChatsContextImport.conversationDetail!
                            .members_count! ?? ""
                        } members`
                    : textCase(chatSelected?.title!)
                  : textCase(chatSelected?.title!)}
              </TextBlock>
            </Div>
          </Div>
        </Div>
      )}
    </>
  );
};
